import React, {Component} from 'react'
import {withTranslation} from 'react-i18next'
import {connect} from 'react-redux'

import employeeService from '../../../services/Employee.service'

import {
  PageHeader,
  PageHeaderColorScheme,
  PageHeaderLink,
  PageHeaderList,
} from '@amzn/stencil-react-components/page'

export class Footer extends Component {

  getFooterItems = (t, employee) => {
    let footerItems = [];

    if (!employeeService.hasSingleBrokerChoice(employee)) {
      footerItems.push(
        <PageHeaderLink dataTestId="Footer-ContactFidelityLink" href="https://nb.fidelity.com/public/nb/default/resourceslibrary/articles/HowtoContactaFidelitySPSRep" target="_blank">{t('Footer.ContactFidelity')}</PageHeaderLink>
      );
    }

    footerItems.push(
      <PageHeaderLink dataTestId="Footer-ContactMorganLink" href="https://www.morganstanley.com/msatwork/amazon/en/contact.html" target="_blank">{t('Footer.ContactMorgan')}</PageHeaderLink>
    );

    footerItems.push(
      <PageHeaderLink dataTestId="Footer-ProvideFeedbackLink" href="https://amazonvoe.eu.qualtrics.com/jfe/form/SV_9B3uT8ztFvrMF0x" target="_blank">{t('Footer.ProvideFeedback')}</PageHeaderLink>
    );

    return footerItems;
  }

  render() {
    const {t, employee} = this.props;

    return (
      <PageHeader colorScheme={PageHeaderColorScheme.Inverted} aria-label="Page footer">
        <nav aria-label="Footer" style={{display: 'flex', flex: 1, justifyContent: 'center'}}>
          <PageHeaderList
            items={this.getFooterItems(t, employee)}
          />
        </nav>
      </PageHeader>
    )
  }
}

const mapState = state => ({
  employee: state.employee
})

export default connect(mapState)(withTranslation('translationsV2')(Footer))
